import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject, tap } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Location } from '@angular/common';

export interface INav {
  active: boolean,
  created_at: string,
  icon: string,
  id: number,
  link: string,
  modules_id: number,
  p_create: boolean,
  p_delete: boolean,
  p_especial1: boolean,
  p_especial2: boolean,
  p_export: boolean,
  p_import: boolean,
  p_print: boolean,
  p_update: boolean,
  title: string,
  type: string,
  updated_at: string,
}

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public navigationData :any;
  public _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
  public flag:boolean = false;

  public static response:any

  /**
   * Constructor
   */
  constructor(
    private _httpClient: HttpClient

  ) {
    this.navigationData 
  }







  get navigation$(): Observable<Navigation> {
    return this._navigation.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get all navigation data
   */



  get(): Observable<any> {
    return this._httpClient.get<Navigation>(environment.apiURL + 'navigation/availablenav').pipe(
      tap((navigation) => {
        this._navigation.next(navigation);
        this.navigationData = navigation
        NavigationService.response=navigation
        this.flag=true;


      })
    );

  }



  static getPermisos():INav{
    let menu : any[] = this.response.default
    let decode = window.location.href.split('#')[1].split('/')

    let path = decode[1]+'/'
    
    let modulo = menu.find(m  => m.link_root == path )

    let submodulo = modulo.children.find(s =>s.link ==decode[1]+'/'+decode[2])
    return submodulo
  }


  // get(): Observable<Navigation> {
  //   return of(this.navigationData).pipe(
  //     tap(navigation => {
  //       this._navigation.next(navigation);
  //     })
  //   );
  // }


}
